import React from 'react'
import PropTypes from 'prop-types'

import { Box, Grid, InputLabel, TextField, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { ExpandMore } from '@material-ui/icons'
import { Controller } from 'react-hook-form'

import constants from 'constants/index'
import useStyles from './styles'

const StatusFilter = ({ control, errors, onSelect }) => {
  const classes = useStyles()

  return (
    <Grid item xs={12}>
      <Box display="flex">
        <InputLabel className={classes.label}>Status</InputLabel>
        <Typography className={classes.subLabel}>(opcional)</Typography>
      </Box>
      <Controller
        control={control}
        name="statuses"
        mode="onChange"
        onChange={([, data]) => {
          onSelect()
          return data
        }}
        as={
          <Autocomplete
            popupIcon={<ExpandMore />}
            className={classes.input}
            multiple
            options={constants.dataProcess.STATUS_OPTIONS}
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                error={!!errors?.statuses}
                helperText={errors?.statuses?.message}
              />
            )}
          />
        }
      />
    </Grid>
  )
}

StatusFilter.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onSelect: PropTypes.func,
}

StatusFilter.defaultProps = {
  errors: {},
  onSelect: () => {},
}

export default StatusFilter
